import { jsx as _jsx } from "react/jsx-runtime";
import * as API_NAMES from 'self-service-api/constants/ApiNames';
import CompareProFeatureTable from '../feature-table/CompareProFeatureTable';
import PersonalizedSuiteStarterFeatureTableContainer from './suite-starter-page/PersonalizedSuiteStarterFeatureTableContainer';
const FEATURE_TABLE_ELIGIBLE_HUBS = [API_NAMES.CRM_SUITE_STARTER_BUNDLE, API_NAMES.MARKETING_HUB_STARTER, API_NAMES.MARKETING_HUB_PROFESSIONAL, API_NAMES.MARKETING_HUB_ENTERPRISE, API_NAMES.SALES_HUB_STARTER, API_NAMES.SALES_HUB_PROFESSIONAL, API_NAMES.SALES_HUB_ENTERPRISE, API_NAMES.SERVICE_HUB_STARTER, API_NAMES.SERVICE_HUB_PROFESSIONAL, API_NAMES.SERVICE_HUB_ENTERPRISE, API_NAMES.CMS_HUB_STARTER, API_NAMES.CMS_HUB_PROFESSIONAL, API_NAMES.CMS_HUB_ENTERPRISE, API_NAMES.OPERATIONS_HUB_STARTER, API_NAMES.OPERATIONS_HUB_PROFESSIONAL, API_NAMES.OPERATIONS_HUB_ENTERPRISE];
export const isEligibleForFeatureTable = upgradePointApiName => {
  return FEATURE_TABLE_ELIGIBLE_HUBS.includes(upgradePointApiName);
};

const PersonalizedFeatureTableContainer = ({
  upgradePointApiName
}) => {
  if (upgradePointApiName === API_NAMES.CRM_SUITE_STARTER_BUNDLE) {
    return /*#__PURE__*/_jsx(PersonalizedSuiteStarterFeatureTableContainer, {});
  } else {
    return /*#__PURE__*/_jsx(CompareProFeatureTable, {
      upgradePointApiName: upgradePointApiName
    });
  }
};

export default PersonalizedFeatureTableContainer;